import { questionService } from '../services';

export const questionActions = {
    fetchQuestion,
    fetchCoinImage,
    submitAnswer,
    captureCoin
};

function fetchQuestion(studentid, gameid, questionid, gamelineid, direction) {
    return dispatch => {

        return questionService.fetchQuestion(studentid, gameid, questionid, gamelineid, direction)
            .then(
                response => {
                    return response.data;
                },
                error => {
                    return error;
                }
            );
    };

}

function fetchCoinImage() {
    return dispatch => {

        return questionService.fetchCoinImage()
            .then(
                response => {
                    return response.data;
                },
                error => {
                    return error;
                }
            );
    };

}

function submitAnswer(answerData) {
    return dispatch => {

        return questionService.submitAnswer(answerData)
            .then(
                response => {
                    return response;
                },
                error => {
                    return Promise.reject(error);
                }
            );
    };

}

function captureCoin(coinData) {
    return dispatch => {

        return questionService.captureCoin(coinData)
            .then(
                response => {
                    return response;
                },
                error => {
                    return Promise.reject(error);
                }
            );
    };

}